<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCoupon({ couponName: $t('common.all'), couponId: '' })"
              :class="{ 'selected': giveLogInfo.conditions.couponId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in giveLogInfo.coupons" :key="index"
              @click="switchCoupon(item)"
              :class="{ 'selected': giveLogInfo.conditions.couponId == item.couponId }">
              {{ item.couponName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="giveLogInfo.conditions.userName"
                :placeholder="$t('couponManage.userName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="giveLogInfo.conditions.tel"
                :placeholder="$t('couponManage.phoneNumber')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryGiveLogMethod()">
                <i class="el-icon-search"></i> {{ $t('couponManage.query') }}
              </el-button>
              <el-button @click="_resetGiveLogMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.giveLogs') }}</span>
            <el-button type="primary" size="small" @click="_openGiveCouponModal()">
              {{ $t('couponManage.give') }}
            </el-button>
          </div>
          <el-table :data="giveLogInfo.giveLogs" border style="width:100%" v-loading="loading">
            <el-table-column prop="giveId" :label="$t('couponManage.id')" align="center" />
            <el-table-column prop="couponName" :label="$t('couponManage.couponName')" align="center" />
            <el-table-column prop="receiveUserName" :label="$t('couponManage.userName')" align="center" />
            <el-table-column prop="receivePhone" :label="$t('couponManage.phoneNumber')" align="center" />
            <el-table-column prop="createTime" :label="$t('couponManage.giveTime')" align="center" />
            <el-table-column prop="givePersonName" :label="$t('couponManage.giveUser')" align="center" />
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="giveLogInfo.conditions.page"
            :page-size="giveLogInfo.conditions.row" layout="total, prev, pager, next"
            :total="giveLogInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <give-coupon-from-list ref="giveCouponFromList" @refresh="_listGiveLogs" />
  </div>
</template>

<script>
import { listCouponGiveLog, listShopCoupon } from '@/api/coupon/couponApi'
import GiveCouponFromList from '@/components/coupons/giveCouponFromList/giveCouponFromList'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CouponGiveLogManage',
  components: {
    GiveCouponFromList
  },
  data() {
    return {
      loading: false,
      giveLogInfo: {
        giveLogs: [],
        coupons: [],
        total: 0,
        conditions: {
          userName: '',
          tel: '',
          couponId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.giveLogInfo.conditions.shopId = getShopId()
    this._listCoupons()
    this._listGiveLogs()
  },
  methods: {
    async _listCoupons() {
      try {
        const res = await listShopCoupon({
          shopId: getShopId(),
          page: 1,
          row: 100
        })
        this.giveLogInfo.coupons = res.data || []
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      }
    },
    async _listGiveLogs() {
      this.loading = true
      try {
        const res = await listCouponGiveLog(this.giveLogInfo.conditions)
        this.giveLogInfo.giveLogs = res.data
        this.giveLogInfo.total = res.total
      } catch (error) {
        console.error('获取赠送记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryGiveLogMethod() {
      this.giveLogInfo.conditions.page = 1
      this._listGiveLogs()
    },
    _resetGiveLogMethod() {
      this.giveLogInfo.conditions.userName = ''
      this.giveLogInfo.conditions.tel = ''
      this.giveLogInfo.conditions.page = 1
      this._listGiveLogs()
    },
    handleCurrentChange(val) {
      this.giveLogInfo.conditions.page = val
      this._listGiveLogs()
    },
    _openGiveCouponModal() {
      this.$refs.giveCouponFromList.open()
    },
    switchCoupon(coupon) {
      this.giveLogInfo.conditions.couponId = coupon.couponId || ''
      this.giveLogInfo.conditions.page = 1
      this._listGiveLogs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>

